import $ from 'jquery';
import apiClient from '../client';
import $U from '../urls';

export const getCsrfToken = () => {
  return apiClient.request('GET', $U.CSRF_TOKEN);
};

export const subscription = (email) => {
  return apiClient.request('POST', $U.SUBSCRIPTION, email);
};

export const searchAutocomplete = query => {
  const params = { search_text: query };
  return apiClient.request('GET', $U.SEARCH_AUTOCOMPLETE, params);
};

export const fetchStores = (params = { format: 'json' }) => {
  return apiClient.request('GET', $U.STORES, params);
};

export const fetchStoresByCoordinates = (
  latitude,
  longitude,
  nearest = false,
) => {
  const params = {
    latitude,
    longitude,
    radius: 1,
    quantity: 20,
    format: 'json',
  };

  if (nearest) {
    params.nearest = true;
  }

  return fetchStores(params);
};

export const fetchMenu = (depth = 3) => {
  const params = {
    depth_height: depth,
    format: 'json',
  };

  return apiClient.request('GET', $U.MENU, params);
};

export const fetchPageHtml = (url) => {
  return new Promise((resolve, reject) => {
    $.ajax({
      url,
      beforeSend(xhr) {
        xhr.setRequestHeader('Accept', 'text/html');
      },
      success: response => resolve(response),
      error: errors => reject(errors),
    });
  });
};
